import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import ManageUserService from "../../api/ManageUserService";
import AuthService from "../../session/AuthService";
import { Toaster, toast } from "react-hot-toast";



class CreateEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      male: false,
      female: false,
      formValues: {},
      isLoading: false,
    };
  }

  componentDidMount = () => {
   
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      // let male = null;
      // let female = null;

      // if (this.props.editValue.gender === "male") {
      //   male = true;
      //   female = false;
      // } else if (this.props.editValue.gender === "female") {
      //   female = true;
      //   male = false;
      // } else {
      //   male = false;
      //   female = false;
      // }

      this.setState({
        formValues: this.props.editValue,
        // male: male,
        // female: female,
      });
    }
    toast.dismiss();
  };

  render() {
    const { formValues, isLoading } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit" ? "Edit Employee" : "Add Employee"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label> First Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="First Name"
                autoFocus
                className="small-input"
                name="firstName"
                value={formValues.firstName}
                onChange={this.onChangeformValues}
                style={{height : "40px"}}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Last Name"
                autoFocus
                className="small-input"
                name="lastName"
                value={formValues.lastName}
                onChange={this.onChangeformValues}
                style={{height : "40px"}}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                // placeholder="Email"
                autoFocus
                className="small-input"
                name="email"
                value={formValues.email}
                onChange={this.onChangeformValues}
                style={{height : "40px"}}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                // placeholder="Phone Number"
                autoFocus
                className="small-input"
                name="phoneNo"
                value={formValues.phoneNo}
                onChange={this.onChangeformValues}
                style={{height : "40px"}}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            {/* <Row>
              <Col style={{ marginBottom: "9px" }}>
                <label
                  style={{
                    fontWeight: "400",
                    marginTop: "10px",
                    fontWeight: 500,
                  }}
                  className="CustomFormLabel"
                >
                  {"Gender"}
                </label>
                <div style={{ marginLeft: "3px" }}>
                  <div style={{ display: "inline-block", marginRight: "10px" }}>
                    <label className="CustomFormLabel">Male</label>
                    <input
                      type="radio"
                      id="option11"
                      name="male"
                      checked={this.state.male}
                      onClick={(e) => this.handlechangechecked(e)}
                    />
                  </div>

                  <div style={{ display: "inline-block" }}>
                    <label className="CustomFormLabel">Female</label>
                    <input
                      type="radio"
                      id="option12"
                      name="female"
                      checked={this.state.female}
                      onClick={(e) => this.handlechangechecked2(e)}
                    />
                  </div>
                </div>
              </Col>
            </Row> */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>
            {String(AuthService.getUserTypeAdmin()) !== "3" && (
                <Button variant="success" type="button" onClick={this.saveEmployee} style={{width : "11rem"}}>
                {isLoading && <span className="loader-button" />}
               <span> {this.props.option === "edit" ? "Edit Employee" : "Add Employee"}</span>
              </Button>
            )}
           
          </Modal.Footer>
        </Modal>
        <Toaster />
      </>
    );
  }

  handlechangechecked2 = () => {
    this.setState(
      {
        female: !this.state.female,
        male: false,
      }
    );
  };

  // to handlechanged checked to keromeos  as true  to set value
  handlechangechecked = () => {
    this.setState(
      {
        male: !this.state.male,
        female: false,
      }
    );
  };

  onChangeformValues = (event) => {
    let form = { ...this.state.formValues };
    form[event.target.name] = event.target.value;
    this.setState({
      formValues: form,
    });
  };

  saveEmployee = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (this.props.option === "edit") {
     
      if (!this.state.formValues.firstName) {

        this.props.errorToast("Please Enter a First Name");
      

      }else if (
        !this.state.formValues.email ||
        !emailRegex.test(this.state.formValues.email)
      ) {
       
        this.props.errorToast("Please Enter a Valid Email");
      
      } else {
        let form = { ...this.state.formValues };

        // let gender = "";
        // if (this.state.male === true) {
        //   gender = "male";
        // } else if (this.state.female === true) {
        //   gender = "female";
        // } else {
        //   gender = "";
        // }
        // form["gender"] = gender;
        form["profileImage"] = "";
        form["profileCoverImage"] = "";
        form["userId"] = parseInt(AuthService.getUserId());
        this.setState({ isLoading: true });
        ManageUserService.editUser(form).then((response) => {
          console.log("response", response);
          if (response.data && response.data.message === "Success") {
            this.setState({ isLoading: false });
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Edit");
          } else if (
            response.data &&
            response.data.data === "Email address already exists"
          ) {
            this.props.errorToast("Email Address Already Exists");
            
            this.setState({ isLoading: false });
          }
        });
      }
    } else {
      if (!this.state.formValues.firstName) {
       
        this.props.errorToast("Please Enter First Name");
      
       
      } else if (
        !this.state.formValues.email ||
        !emailRegex.test(this.state.formValues.email)
      ) {
        this.props.errorToast("Please Enter a Valid Email");

      } else {
        let form = { ...this.state.formValues };

        let gender = "";
        if (this.state.male === true) {
          gender = "male";
        } else if (this.state.female === true) {
          gender = "female";
        } else {
          gender = "";
        }
        form["gender"] = gender;

        form["profileImage"] = "";
        form["profileCoverImage"] = "";
        form[
          "url"
        ] = `${window.location.origin}/FarmShopConnectAdmin/ResetPassword?id=`;
        form["userId"] = parseInt(AuthService.getUserId());

        this.setState({ isLoading: true });
        ManageUserService.saveEmployee(form).then((response) => {
         

          if (response.data && response.data.message === "Success") {
        

         
              
              this.setState({ isLoading: false });
              this.props.handleClose();
              this.props.onLoad();
              this.props.renderToast("Create");
          
         } else if (
            response.data &&
            response.data.data === "Email Address already present"
          ) {
            toast.error("Email Address Already Present");
            this.setState({ isLoading: false });
          } else if (
            response.data &&
            response.data.data === "Phone Number already present"
          ) {
           toast.error("Mobile Number Already Present");
            this.setState({ isLoading: false });
          } else {
          }
        });
      }
    }
  };
}
export default CreateEmployee;
